import { times } from 'lodash/fp'

import { Flex, Heading, SimpleGrid, Skeleton } from '@masterplandev/ui'

import { nbsp } from '@/core/richTextElements'

import { CardSkeleton } from '../AchievementsCard/CardSkeleton'

export const ContentSkeleton = () => {
  return (
    <>
      <Skeleton rounded="full" w="64">
        <Heading size="h5" mb="4">
          {nbsp}
        </Heading>
      </Skeleton>
      <Flex flexWrap="wrap" gap="4" mb="8">
        {times(
          (groupIndex: number) => (
            <SimpleGrid
              border="1px solid"
              borderColor="mp2.neutralDark.300A"
              columns={{ base: 2, md: 4 }}
              gap={4}
              key={groupIndex}
              p={{ base: 4, md: 2 }}
              rounded="xl">
              {times(
                (index: number) => (
                  <CardSkeleton key={index} />
                ),
                4,
              )}
            </SimpleGrid>
          ),
          2,
        )}
      </Flex>
    </>
  )
}
